var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KCheckbox',{attrs:{"label":`selectedNumber = ${_vm.selectedNumber}`,"value":1},model:{value:(_vm.selectedNumber),callback:function ($$v) {_vm.selectedNumber=$$v},expression:"selectedNumber"}})
}
var staticRenderFns = []

export { render, staticRenderFns }